import { useState } from "react";
import { Button } from "./ui";

// Унифицированное поле с копированием в буфер. Заменяет
// LinkRow / CopyRow / CopyButton — три копии одной логики, которые
// расходились на ServerDetails и ClusterDetails.
//
// size="lg" — ServerDetails-стиль (font-mono + Button "Копировать")
// size="sm" — ClusterDetails-стиль (компактная кнопка "Копир.")
// size="button-only" — только кнопка без поля (для inline-копирования)

interface Props {
  text: string;
  size?: "lg" | "sm" | "button-only";
  mono?: boolean;
  label?: string;
}

export function CopyField({
  text,
  size = "lg",
  mono = true,
  label,
}: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore — Safari иногда отрубает clipboard вне user gesture */
    }
  };

  if (size === "button-only") {
    return (
      <Button variant="ghost" onClick={copy}>
        {copied ? "Скопировано ✓" : label ?? "Копировать"}
      </Button>
    );
  }

  if (size === "sm") {
    return (
      <div className="flex gap-2 items-stretch">
        <div
          className={`flex-1 px-3 py-2 rounded-lg bg-zinc-950 border border-zinc-800 text-xs text-zinc-100 break-all ${
            mono ? "font-mono" : ""
          }`}
        >
          {text}
        </div>
        <button
          onClick={copy}
          className="h-auto px-3 text-xs font-medium rounded-md border bg-zinc-900 text-zinc-200 border-zinc-800 hover:bg-zinc-700 hover:text-white hover:border-zinc-600 transition-colors"
        >
          {copied ? "✓" : "Копир."}
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-3 items-stretch">
      <div
        className={`flex-1 px-3 py-2 rounded-lg bg-zinc-950 border border-zinc-800 text-xs text-zinc-100 break-all ${
          mono ? "font-mono" : ""
        }`}
      >
        {text}
      </div>
      <Button variant="ghost" onClick={copy}>
        {copied ? "Скопировано ✓" : label ?? "Копировать"}
      </Button>
    </div>
  );
}
